import p from './store-bind-log.vue';

export default p;
